(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tb-feature-build"] && !Shopify.designMode) return;
  try {
    
function initTurboBuild(root){
 root.querySelectorAll('[data-tb-build]').forEach(section=>{
  if(section.dataset.ready)return;
  section.dataset.ready='true';
  const form=section.querySelector('[data-build-form]');
  form.addEventListener('submit',event=>event.preventDefault());
  section.querySelector('[data-build-prepare]').addEventListener('click',()=>{
   if(!form.reportValidity())return;
   const values=new FormData(form);
   const lines=[];
   ['name','email','vehicle','turbo','story','credit'].forEach(key=>{
    const input=form.elements.namedItem(key);
    lines.push(input.labels[0].textContent.trim()+': '+String(values.get(key)||'').trim());
   });
   lines.push('',section.dataset.review,values.has('public_consent')?section.dataset.yes:section.dataset.no,'',section.dataset.photos);
   const body=lines.join('\n');
   section.querySelector('[data-build-draft]').value=body;
   section.querySelector('[data-build-mail]').href='mailto:sales@turbobits.co.nz?subject='+encodeURIComponent(section.dataset.subject)+'&body='+encodeURIComponent(body);
   const result=section.querySelector('[data-build-result]');result.hidden=false;result.focus();
  });
  form.addEventListener('input',()=>{section.querySelector('[data-build-result]').hidden=true;section.querySelector('[data-build-mail]').removeAttribute('href');section.querySelector('[data-build-draft]').value='';});
 });
}
initTurboBuild(document);
document.addEventListener('shopify:section:load',event=>initTurboBuild(event.target));

  } catch(e) { console.error(e); }
})();
})();
